module.exports = __webpack_public_path__ + "static/media/dpeScreenshot.14e708bc.png";